import { render, staticRenderFns } from "./chatContent.vue?vue&type=template&id=dc530cfe&scoped=true&"
import script from "./chatContent.vue?vue&type=script&lang=js&"
export * from "./chatContent.vue?vue&type=script&lang=js&"
import style0 from "./chatContent.vue?vue&type=style&index=0&id=dc530cfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc530cfe",
  null
  
)

export default component.exports